module.exports = __webpack_public_path__ + "img/yuezhifu4.da410b32.png";